import { CATEGORY_DISTRIBUTION_CARD_TEST_IDS } from '@/constants/data-testids';

import { Card, CardContent } from '../../atoms/Card/Card';
import { Skeleton } from '../../atoms/Skeleton/Skeleton';

export const CategoryDistributionCardSkeleton = () => {
  return (
    <Card
      data-testid={CATEGORY_DISTRIBUTION_CARD_TEST_IDS.SKELETON}
      className="rounded-[12px] px-4 py-3"
    >
      <CardContent>
        <Skeleton className="mb-[22px] w-[126px] h-[14px]" />
        <Skeleton className="w-[80px] h-[14px]" />
      </CardContent>
    </Card>
  );
};
